import { http } from '../../helpers';
import { fetchClinics } from './fetchClinics';

export function deleteClinic(id) {
    return (dispatch) => {
        const relativeUrl = `/case-api/clinics/${id}`;
        http.delete(relativeUrl)
            .then((res) => {
                if (res.status === 200) {
                    dispatch(fetchClinics());
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    };
}
